export default __webpack_public_path__ + "static/media/jpg.04b9026c.svg";